module.exports = __webpack_public_path__ + "static/media/Around-img-1@2x.aa8a174a.jpg";